import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../containers/checkoutPage/CheckoutPage.m.sass';

import PaypalIcon from '-!svg-react-loader?name=PaypalIcon!../../assets/images/payment-methods/paypal.svg';
import MasterCardIcon from '-!svg-react-loader?name=MasterCardIcon!../../assets/images/payment-methods/mastercard.svg';
import MaestroIcon from '-!svg-react-loader?name=MaestroIcon!../../assets/images/payment-methods/maestro.svg';
import VisaIcon from '-!svg-react-loader?name=VisaIcon!../../assets/images/payment-methods/visa.svg';
import VisaElectronIcon from '-!svg-react-loader?name=VisaElectronIcon!../../assets/images/payment-methods/visa-electron.svg';

export default function PaymentMethodField({methods, input, meta: {touched, error}}) {


  return (
    <div className={styles.checkout_paymentsWrap}>
      <div className={styles.checkout_payment}>
        <div className={styles.payments}>
          <div className={styles.payments_wrapper}>
            <div className={`${styles.payments_item} ${styles.payments_item__active}`}>
              <div className={styles.payments_itemWrapper}>
                <PaypalIcon/>
              </div>
            </div>

            {/* <div className={styles.payments_item}>
              <div className={styles.payments_itemWrapper}>
                <MasterCardIcon/>
              </div>
            </div>

            <div className={styles.payments_item}>
              <div className={styles.payments_itemWrapper}>
                <MaestroIcon/>
              </div>
            </div>

            <div className={styles.payments_item}>
              <div className={styles.payments_itemWrapper}>
                <VisaIcon/>
              </div>
            </div>

            <div className={styles.payments_item}>
              <div className={styles.payments_itemWrapper}>
                <VisaElectronIcon/>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <div className={styles.checkout_paymentsLinks}>
        <a href="#" className={styles.checkout_link}>What is PayPal?</a>
        <div className={styles.checkout_paymentsAdvice}>
          You can pay with your credit card if you dont’t have a PayPal account
        </div>
      </div> */}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/checkout/PaymentMethodField.js